// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"115":"forum/emojiNamesFr","529":"forum/emojiSearchFr"}[chunkId] + ".js";
};